import { Typography } from '@ag1/ui';
import styles from './LegalText.module.scss';

type LegalTextProps = {
  text: string;
  showSuperScript?: boolean;
  className?: string;
};

const LegalText = ({ text, showSuperScript = false, className = '' }: LegalTextProps) => {
  if (!text) return null;

  return (
    <Typography variant="caption" size="1" noPadding className={`${styles.legalText} ${className}`}>
      {showSuperScript && <sup className={styles.legalSuper}>†</sup>}
      {text}
    </Typography>
  );
};

export default LegalText;
